// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__CDli8","active":"Tab_active__hMxJQ"};